import {FC} from "react";
import {useAuth} from "../AuthContext";
import {useLocation, useNavigate} from "react-router-dom";

interface SignOutButtonProps {
    isOpen: boolean;
}

export const SignOutButton: FC<SignOutButtonProps> = ({isOpen}) => {
    const {logout} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = location.pathname === "/login";

    const handleSignOut = () => {
        logout();
        localStorage.removeItem("token");
        navigate("/login");
    };

    return (
        <button
            className={`lg:block w-full px-4 py-2 bg-gray-800 hover:bg-gray-700 text-start ${isActive && "font-bold"} ${isOpen ? "block" : "hidden"}`}
            onClick={handleSignOut}
        >
            Odhlásit se
        </button>
    );
};
